import { jsx } from "panel";
import { AuthHeaderEl } from "common/widgets/auth-container/auth-header";
import { AuthFooterEl } from "common/widgets/auth-container/auth-footer";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".auth-container" }, !this.attr(`hide-header`) && /* @__PURE__ */ jsx(AuthHeaderEl, null), /* @__PURE__ */ jsx("slot", { attrs: { name: `auth-form-slot` } }), /* @__PURE__ */ jsx(
    AuthFooterEl,
    {
      attrs: {
        "show-footer-links": this.attr(`show-footer-links`)
      }
    }
  ));
}
